import {TranslateLoader} from "@ngx-translate/core";
import {Observable, of} from "rxjs";
import {TranslationRepository} from "../repositories/translation.repository";

export class TranslationLoader implements TranslateLoader {

  constructor(private translationRepository: TranslationRepository) {

  }

  getTranslation(langCode: string): Observable<any> {
    console.log(`Loading translation for language: ${langCode}`);
    return this.translationRepository.getCompleteTranslationObject(langCode);
  }
}
